(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.application = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require("./BAT.stringsUtils.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _version_BAT_application = "1.0.0.0";
var _name_BAT_application = "Omnia Shop";

var application = exports.application = function () {
    function application() {
        _classCallCheck(this, application);
    }

    _createClass(application, null, [{
        key: "version",
        get: function get() {
            return _version_BAT_application;
        },
        set: function set(version) {
            _version_BAT_application = version;
        }
    }, {
        key: "name",
        get: function get() {
            return _name_BAT_application;
        },
        set: function set(name) {
            _name_BAT_application = name;
        }
    }, {
        key: "localStoragePref",
        get: function get() {
            return _name_BAT_application.normalize().replaceAll(' ', '');
        }
    }]);

    return application;
}();
},{"./BAT.stringsUtils.js":14}],2:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (!Array.prototype.select) {
    Array.prototype.select = function (expr) {
        var arr = this;

        switch (typeof expr === 'undefined' ? 'undefined' : _typeof(expr)) {

            case 'function':
                return $.map(arr, expr);
                break;

            case 'string':

                try {

                    var func = new Function(expr.split('.')[0], 'return ' + expr + ';');
                    return $.map(arr, func);
                } catch (e) {

                    return null;
                }

                break;

            default:
                throw new ReferenceError('expr not defined or not supported');
                break;
        }
    };
}
if (!Array.prototype.where) {
    Array.prototype.where = function (filter) {

        var collection = this;

        switch (typeof filter === 'undefined' ? 'undefined' : _typeof(filter)) {

            case 'function':
                return $.grep(collection, filter);

            case 'object':
                for (var property in filter) {
                    if (!filter.hasOwnProperty(property)) continue;

                    collection = $.grep(collection, function (item) {
                        return item[property] === filter[property];
                    });
                }
                return collection.slice(0);

            default:
                throw new TypeError('func must be either a' + 'function or an object of properties and values to filter by');
        }
    };
}
if (!Array.prototype.firstOrDefault) {
    Array.prototype.firstOrDefault = function (func) {
        return this.where(func)[0] || null;
    };
}

if (!Array.prototype.distinct) {
    Array.prototype.distinct = function () {
        var myAr = this;
        var uniqueNames = [];
        $.each(myAr, function (i, el) {
            if ($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
        });
        return uniqueNames;
    };
}

if (!Array.prototype.toTreeObject) {
    Array.prototype.toTreeObject = function () {
        var listIdx = 0;
        var resObject = {};
        function addNode(parent, list) {
            parent[list[listIdx]] = parent[list[listIdx]] || { CODIGO: list[listIdx], parent: parent.CODIGO };
            var cPar = parent[list[listIdx]];
            cPar.hijos = cPar.hijos || {};
            if (list[listIdx].length < 5) {
                listIdx = listIdx + 1;
                while (listIdx < list.length && list[listIdx].indexOf(cPar.CODIGO) === 0) {
                    addNode(cPar.hijos, list, listIdx);
                }
            } else {
                listIdx++;
            }
        }
        function addNodes(parent, list) {
            while (listIdx < list.length) {
                addNode(parent, list);
            }
        };
        addNodes(resObject, this);
        return resObject;
    };
}
},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.noImplementado = noImplementado;
exports.warn = warn;
exports.getUrlWebApi = getUrlWebApi;
exports.setUrlWebApi = setUrlWebApi;
exports.getUrlRoot = getUrlRoot;
exports.setUrlRoot = setUrlRoot;
exports.getLocation = getLocation;
exports.getPathPrefix = getPathPrefix;
exports.isFunction = isFunction;
exports.equalsPOCO = equalsPOCO;
exports.getFirstDifferencePOCO = getFirstDifferencePOCO;
exports.roundN = roundN;
exports.initSize = initSize;
exports.getScaledHeight = getScaledHeight;
exports.getUnscaledHeight = getUnscaledHeight;
exports.getScaledWidth = getScaledWidth;
exports.getUnscaledWidth = getUnscaledWidth;
exports.zoomIn = zoomIn;
exports.zoomOut = zoomOut;
exports.applyZoom = applyZoom;
exports.getInitialW = getInitialW;
exports.getInitialH = getInitialH;
exports.disableDiv = disableDiv;
exports.enableDiv = enableDiv;
exports.numMesToStr = numMesToStr;
exports.loadScript = loadScript;
exports.loadCachedScript = loadCachedScript;
exports.loadScripts = loadScripts;
exports.loadCachedScripts = loadCachedScripts;
exports.respuestaCorrecta = respuestaCorrecta;
exports.encrypt = encrypt;
exports.decrypt = decrypt;
exports.getStableHash = getStableHash;
exports.getComputedUUID = getComputedUUID;
exports.TipoDocumentoString = TipoDocumentoString;
exports.getNumberInfo = getNumberInfo;
exports.getNumberMaxLengths = getNumberMaxLengths;
exports.getNumberPre = getNumberPre;
exports.hayInternet = hayInternet;
exports.outerHTML = outerHTML;
exports.guardarHtml = guardarHtml;
exports.guardarError = guardarError;
exports.generateExceptionTest = generateExceptionTest;
exports.setProgress = setProgress;
exports.mostrarPagina = mostrarPagina;
exports.getPaginaActivaID = getPaginaActivaID;
exports.cargarPagina = cargarPagina;
exports.cargarDialogo = cargarDialogo;
exports.cargarControl = cargarControl;
exports.cargarElementoImp = cargarElementoImp;
exports.doneTyping = doneTyping;
exports.sinScroll = sinScroll;
exports.serializeUriParams = serializeUriParams;
exports.serializePageJSParams = serializePageJSParams;
exports.simularClick = simularClick;
exports.getTableFromJson = getTableFromJson;
exports.toLowerCaseKeys = toLowerCaseKeys;
exports.pushCustomAction = pushCustomAction;
exports.popCustomAction = popCustomAction;
exports.isDebug = isDebug;
exports.isFormacion = isFormacion;
exports.getScrType = getScrType;
exports.isScrolledIntoView = isScrolledIntoView;
exports.isScrolledIntoScroll = isScrolledIntoScroll;

var _initialHeight_BAT_core = 0;
var _initialWidth_BAT_core = 0;
var _urlWebApi_BAT_core = '';
var _urlRoot_BAT_core = '';
var _customaActionName_BAT_core = 'customActions';
function _applyZoom_BAT_core(zoomValue) {
    var zoomLevel = 0,
        zoomPixels = 1280;
    zoomLevel = 1;
    if (typeof zoomValue === 'undefined' || zoomValue === null || zoomValue === 0) {
        zoomLevel = BAT.app.current.userConfig().factorZoom;
    } else {
        zoomLevel = parseInt(zoomValue, 10);
    }

    var style = document.getElementById('styleZoom');
    if (style === null || typeof style === 'undefined') {
        style = document.createElement('style');
        $(style).attr('id', 'styleZoom');
    } else {
        $(style).empty();
    }
    zoomPixels = zoomPixels - zoomLevel * 90;
    if (zoomPixels < 320) zoomPixels = 320;
    style.type = 'text/css';
    style.innerHTML = '@viewport{width:' + zoomPixels.toString() + 'px;}@-ms-viewport {width:' + zoomPixels.toString() + 'px;user-zoom:zoom;max-zoom:1;min-zoom:1;}';

    document.getElementsByTagName('head')[0].appendChild(style);
}
function _hayInternet_BAT_core() {
    return navigator.connection.type !== Connection.UNKNOWN && navigator.connection.type !== Connection.NONE;
}
function noImplementado() {
    throw 'Not Implemented';
}
function warn(warning) {
    console.warn(warning);
}
function getUrlWebApi() {
    return _urlWebApi_BAT_core;
}
function setUrlWebApi(value) {
    _urlWebApi_BAT_core = value;
}
function getUrlRoot() {
    return _urlRoot_BAT_core;
}
function setUrlRoot(value) {
    _urlRoot_BAT_core = value;
}
function getLocation(href) {
    var l = document.createElement("a");
    l.href = href;
    return l;
}
function getPathPrefix() {
    return BAT.core.getLocation(BAT.core.getUrlRoot()).pathname.trimEnd('/');
}
function isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
function equalsPOCO(object1, object2) {
    if (object1 !== null && typeof object1 !== 'undefined' && object2 !== null && typeof object2 !== 'undefined') {
        var pn1 = Object.getOwnPropertyNames(object1),
            pn2 = Object.getOwnPropertyNames(object2),
            diffFound = "",
            idx1 = 0;
        if (pn1.length !== pn2.length) return false;
        while (pn1.length > idx1 && pn2.length > idx1 && pn1[idx1] in object1 && pn2[idx1] in object2 && pn1[idx1] === pn2[idx1] && (_typeof(object1[pn1[idx1]]) === _typeof(object2[pn2[idx1]]) || object1[pn1[idx1]] === null || object1[pn1[idx1]] === null || moment.isMoment(object1[pn1[idx1]]) || moment.isMoment(object1[pn2[idx1]]))) {
            idx1++;
        }
        return idx1 === pn1.length;
    } else {
        return false;
    }
}
function getFirstDifferencePOCO(object1, object2) {
    if (object1 !== null && typeof object1 !== 'undefined' && object2 !== null && typeof object2 !== 'undefined') {
        var pn1 = Object.getOwnPropertyNames(object1),
            pn2 = Object.getOwnPropertyNames(object2),
            diffFound = "",
            idx1 = 0;
        if (pn1.length !== pn2.length) {
            return {
                obj1: null,
                obj1Diff: 'diferente longitud',
                obj2: null,
                obj2Diff: null
            };
        }
        while (pn1.length > idx1 && pn2.length > idx1 && pn1[idx1] in object1 && pn2[idx1] in object2 && pn1[idx1] === pn2[idx1] && (_typeof(object1[pn1[idx1]]) === _typeof(object2[pn2[idx1]]) || object1[pn1[idx1]] === null || object1[pn1[idx1]] === null)) {
            idx1++;
        }
        if (idx1 !== pn1.length) {
            return {
                obj1: pn1[idx1],
                obj1Diff: _typeof(object1[pn1[idx1]]),
                obj2: pn2[idx1],
                obj2Diff: _typeof(object2[pn2[idx1]])
            };
        }
    } else {
        return false;
    }
}
function roundN(numero, decimales) {
    return Number(Math.round(numero + 'e' + decimales) + 'e-' + decimales);
}
function initSize() {
    if (_initialHeight_BAT_core === 0) {
        _initialHeight_BAT_core = window.innerHeight;
    }
    if (_initialWidth_BAT_core === 0) {
        _initialWidth_BAT_core = window.innerWidth;
    }
}
function getScaledHeight(value) {
    return parseInt(window.innerHeight * value / _initialHeight_BAT_core, 10);
}
function getUnscaledHeight(value) {
    return parseInt(_initialHeight_BAT_core * value / window.innerHeight, 10);
}
function getScaledWidth(value) {
    return parseInt(window.innerWidth * value / _initialWidth_BAT_core, 10);
}
function getUnscaledWidth(value) {
    return parseInt(_initialWidth_BAT_core * value / window.innerWidth, 10);
}
function zoomIn() {
    BAT.app.current.userConfig().factorZoom += 1;
    _applyZoom_BAT_core();
}
function zoomOut() {
    BAT.app.current.userConfig().factorZoom -= 1;
    _applyZoom_BAT_core();
}
function applyZoom(zoomValue) {
    _applyZoom_BAT_core(zoomValue);
}
function getInitialW() {
    return _initialWidth_BAT_core;
}
function getInitialH() {
    return _initialHeight_BAT_core;
}
function disableDiv(div) {
    if ($(div).length > 0) {
        $(div).addClass("disabledDiv");

        $(div).find("input").each(function () {
            $(this).prop("disabled", true);
        });
    }
}
function enableDiv(div) {
    if ($(div).length > 0) {
        $(div).removeClass("disabledDiv");

        $(div).find("input").each(function () {
            $(this).closest("div").removeClass("ui-state-disabled");
            $(this).prop("disabled", false);
        });
    }
}
function numMesToStr(mes) {
    mes = parseInt(mes);
    if (mes === 1) {
        return "ENE";
    }
    if (mes === 2) {
        return "FEB";
    }
    if (mes === 3) {
        return "MAR";
    }
    if (mes === 4) {
        return "ABR";
    }
    if (mes === 5) {
        return "MAY";
    }
    if (mes === 6) {
        return "JUN";
    }
    if (mes === 7) {
        return "JUL";
    }
    if (mes === 8) {
        return "AGO";
    }
    if (mes === 9) {
        return "SEP";
    }
    if (mes === 10) {
        return "OCT";
    }
    if (mes === 11) {
        return "NOV";
    }
    if (mes === 12) {
        return "DIC";
    }
    return "";
}
function loadScript(url) {
    return $.Deferred(function (def) {
        $.getScript(url, function () {
            def.resolve();
        });
    });
}
function loadCachedScript(url) {
    return $.Deferred(function (def) {
        $.cachedScript(url).done(function () {
            def.resolve();
        }).fail(function () {
            def.reject();
        });
    });
}
function _loadScriptsImp_BAT_core(scripts, idx, def) {
    if (scripts.length > idx) {
        BAT.core.loadScript(scripts[idx]).done(function () {
            _loadScriptsImp_BAT_core(scripts, idx + 1, def);
        }).fail(function () {
            def.reject();
        });
    } else {
        def.resolve();
    }
}
function _loadCachedScriptsImp_BAT_core(scripts, idx, def) {
    if (scripts.length > idx) {
        BAT.core.loadCachedScript(scripts[idx]).done(function () {
            _loadCachedScriptsImp_BAT_core(scripts, idx + 1, def);
        }).fail(function () {
            def.reject();
        });
    } else {
        def.resolve();
    }
}
function loadScripts(scripts) {
    return $.Deferred(function (def) {
        _loadScriptsImp_BAT_core(scripts, 0, def);
    });
}
function loadCachedScripts(scripts) {
    return $.Deferred(function (def) {
        _loadCachedScriptsImp_BAT_core(scripts, 0, def);
    });
}
function respuestaCorrecta(res, allowZero) {
    var hayDatos = function hayDatos() {
        return typeof res.datos !== 'undefined' && res.datos !== null && typeof res.datos.length !== 'undefined' && res.datos.length !== null;
    };
    var hayRes = function hayRes() {
        return typeof res.length !== 'undefined' && res.length !== null;
    };
    if (typeof res !== 'undefined' && res !== null) {
        if (typeof res.statusText !== 'undefined' && res.statusText !== null && res.statusText.toLowerCase() === 'timeout') {
            BAT.showError('Error en las comunicaciones, por favor revise su cobertura WIFI');
            return false;
        } else if (allowZero || hayRes() || hayDatos()) {
            if (typeof res.length !== 'undefined') {
                return allowZero || res.length > 0;
            } else if (typeof res.datos !== 'undefined' && typeof res.datos.length !== 'undefined') {
                return allowZero || res.datos.length > 0;
            } else {
                return allowZero;
            }
        } else {
            return false;
        }
    } else {
        BAT.showError('Error inesperado, por favor repita la operación, si el problema persiste contacte con soporte');
        return false;
    }
}
function encrypt(text) {
    return CryptoJS.AES.encrypt(text, key, { iv: iv }).toString();
}
function decrypt(encrypted) {
    return CryptoJS.AES.decrypt(encrypted, key, { iv: iv }).toString(CryptoJS.enc.Utf8);
}
function getStableHash(texto) {
    return BAT.stringPadLeft((parseInt(JenkinsOAAT(texto)) % 1000000000).toString(), 9, '0');
}
function getComputedUUID() {
    return BAT.getStableHash(device.uuid);
}
function TipoDocumentoString(doc) {
    if (doc === "F") {
        return "Factura";
    }
    if (doc === "A") {
        return "Albarán";
    }
    if (doc === "P") return "Pedido";

    if (doc === "") return "";
}
function getNumberInfo(number) {
    var numberRes = number.toString().split('.'),
        res = new Array(2);
    res[0] = numberRes[0].length;
    res[1] = 0;
    if (numberRes.length > 1 && numberRes[1] !== '') {
        res[1] = numberRes[1].length;
    }
    return {
        lengths: res,
        parts: numberRes
    };
}
function getNumberMaxLengths(dataList, dataPropertyNames) {
    var res = new Array(dataPropertyNames.length),
        tmpval = null;
    $.each(dataList, function (idElm, elem) {
        $.each(dataPropertyNames, function (idProp, prop) {
            tmpval = BAT.getNumberInfo(elem[prop]);
            if (typeof res[idProp] === 'undefined' || res[idProp] === null) {
                res[idProp] = tmpval.lengths;
            } else {
                if (res[idProp][0] < tmpval.lengths[0]) {
                    res[idProp][0] = tmpval.lengths[0];
                }
                if (res[idProp][1] < tmpval.lengths[1]) {
                    res[idProp][1] = tmpval.lengths[1];
                }
            }
        });
    });
    return res;
}
function getNumberPre(number, maxLengths, separator, ocultarSiCero) {
    var pre = $('<pre class="anchoFijoPre">'),
        numberPs = BAT.getNumberInfo(number),
        numberFormat = '',
        _separator = ',';
    if (typeof separator !== 'undefined' && separator !== null) {
        _separator = separator;
    }
    numberFormat += BAT.stringPadLeft(numberPs.parts[0], maxLengths[0], ' ');
    if (numberPs.lengths[1] > 0) {
        numberFormat += _separator;
        numberFormat += numberPs.parts[1];
        numberFormat += BAT.stringPadRight('', maxLengths[1] - numberPs.lengths[1], ' ');
    } else if (maxLengths[1] > 0) numberFormat += BAT.stringPadRight(_separator, maxLengths[1] + 1, '0');
    if (ocultarSiCero === true && parseFloat(numberFormat.replace(_separator, '.')) === 0) {
        pre.append(numberFormat.toString().replaceAll('0', ' ').replaceAll(_separator, ' '));
    } else {
        pre.append(numberFormat);
    }
    return pre;
}
function hayInternet() {
    return _hayInternet_BAT_core();
}
function outerHTML(JQueryObject) {
    return $("<div />").append(JQueryObject.clone()).html();
}
function guardarHtml() {
    return $.Deferred(function (def) {
        var fName = BAT.getComputedUUID() + '_' + moment().toDateID() + '_DOM.log';
        return BAT.fileUtils.create(fName, '<!DOCTYPE html>\r\n' + document.documentElement.outerHTML).done(function () {
            BAT.fileUtils.createFolder(BAT.appFolders.log).done(function (res) {
                BAT.fileUtils.copy(fName, BAT.appFolders.log).done(function (res) {
                    def.resolve();
                }).fail(function (error) {
                    def.reject('Error desconocido copiando log');
                });
            }).fail(function (error) {
                def.reject('Error Creando Directorio de log');
            });
        }).fail(function () {
            def.reject('Error desconocido creando log');
        });
    });
}
function guardarError(mensaje) {
    return $.Deferred(function (def) {
        var fName = BAT.getComputedUUID() + '_' + moment().toDateID() + '_ERROR.log';
        return BAT.fileUtils.create(fName, mensaje).done(function () {
            BAT.fileUtils.createFolder(BAT.appFolders.log).done(function (res) {
                BAT.fileUtils.copy(fName, BAT.appFolders.log).done(function (res) {
                    def.resolve();
                }).fail(function (error) {
                    def.reject('Error desconocido copiando log');
                });
            }).fail(function (error) {
                def.reject('Error Creando Directorio de log');
            });
        }).fail(function () {
            def.reject('Error desconocido creando log');
        });
    });
}
function generateExceptionTest() {
    n.tres = m.cuatro;
}
function setProgress(jqBootstrapProgress, value) {
    jqBootstrapProgress.css('width', value + '%').attr('aria-valuenow', value);
}
function mostrarPagina(nombrePagina, path) {
    $('[data-role="page"]').hide();
    $("#" + nombrePagina + "[data-role=\"page\"]").show();
}
function getPaginaActivaID() {
    var pa = $('[data-role="page"]:visible');
    if (pa !== null && (typeof pa === 'undefined' ? 'undefined' : _typeof(pa)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && pa.length === 1) {
        return $('[data-role="page"]:visible').attr('id');
    } else {
        return '';
    }
}
jQuery.fn.outerHTML = function () {
    return jQuery('<div />').append(this.eq(0).clone()).html();
};
jQuery.cachedScript = function (url, options) {
    options = $.extend(options || {}, {
        dataType: "script",
        cache: true,
        url: url
    });

    return jQuery.ajax(options);
};

function cargarPagina(nombrePagina, version) {
    return cargarElementoImp('/SPA/paginas/', nombrePagina, version);
}

function cargarDialogo(nombreDialogo, version) {
    return cargarElementoImp('/SPA/dialogos/', nombreDialogo, version);
}

function cargarControl(nombreControl, version) {
    return cargarElementoImp('/SPA/control/', nombreControl, version);
}

function cargarElementoImp(relativePath, nombreElemento, version) {
    function getVersionParam(v) {
        if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && v !== null && v !== '') {
            return '?_=' + v;
        } else {
            return '';
        }
    }
    return $.Deferred(function (def) {
        if ($('#' + nombreElemento).length === 0) {
            $.get(BAT.core.getUrlRoot().trim('/') + relativePath + nombreElemento + '/' + nombreElemento + '.html' + getVersionParam(version)).done(function (res) {
                if ($('#ContenedorSPA footer').length === 1) {
                    $(res).filter('#' + nombreElemento).insertBefore($('#ContenedorSPA footer').eq(0));
                } else {
                    $(res).filter('#' + nombreElemento).appendTo($('#ContenedorSPA'));
                }

                def.resolve();
            }).fail(function () {
                def.reject();
            });
        } else {
            def.resolve();
        }
    });
}

function doneTyping(jqSelector, intervaloParadaMilisegundos, callback) {
    https: var typingTimer;
    $(document).on("keyup", jqSelector, function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(callback, intervaloParadaMilisegundos);
    });

    $(document).on("keydown", jqSelector, function () {
        clearTimeout(typingTimer);
    });
}

function sinScroll() {
    return $(window).height() === $(document).height();
}

function serializeUriParams(obj) {
    var str = [];
    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    }return str.join("&");
}

function serializePageJSParams(valuesArray) {
    return valuesArray.join("/");
}

function simularClick(href, params) {
    if ($('a.fake').length === 0) $('<a href="#" class="fake"></a>').appendTo('body');
    if (typeof params !== 'undefined' && params !== null) {
        $('a.fake').attr('href', href.trimEnd('/') + '/' + serializeUriParams(params)).get(0).click();
    } else {
        $('a.fake').attr('href', href).get(0).click();
    }
}

function _addAllColumnHeaders_BAT_core(selector, headersMap) {
    var columnSet = [];
    var headerTr$ = $('<tr/>');

    for (var m = 0; m < headersMap.length; m++) {
        headerTr$.append($('<th/>').html(headersMap[m].columnName).attr('scope', 'col'));
    }

    $(selector).append($('<thead>').append(headerTr$));
}

function _isScrolledIntoView_BAT_core(elem) {
    return _isScrolledIntoScroll_BAT_core(elem, $(window).scrollTop());
}

function _isScrolledIntoScroll_BAT_core(elem, scroll) {
    var docViewTop = scroll;
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

function getTableFromJson(tableSelector, jsonData, headersMap, calculateRowCallback, calculateCellCallback) {
    _addAllColumnHeaders_BAT_core(tableSelector, headersMap);
    var tb$ = $(tableSelector).append('<tbody>');
    for (var i = 0; i < jsonData.length; i++) {
        var row$ = $('<tr/>');
        if ((typeof calculateRowCallback === 'undefined' ? 'undefined' : _typeof(calculateRowCallback)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && calculateRowCallback !== null) {
            calculateRowCallback(row$, jsonData[i]);
        }
        for (var colIndex = 0; colIndex < headersMap.length; colIndex++) {
            var cellValue = jsonData[i][headersMap[colIndex].dataName];
            if (cellValue === null) {
                cellValue = "";
            } else if ((typeof cellValue === 'undefined' ? 'undefined' : _typeof(cellValue)) === (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && (typeof calculateCellCallback === 'undefined' ? 'undefined' : _typeof(calculateCellCallback)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && calculateCellCallback !== null) {
                cellValue = calculateCellCallback(jsonData[i], headersMap[colIndex].columnName, colIndex);
            }
            var td$;
            if (_typeof(headersMap[colIndex].isHeader) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && headersMap[colIndex].isHeader === true) {
                td$ = $('<th/>').html(cellValue);
                td$.attr('scope', 'row');
            } else {
                td$ = $('<td/>').html(cellValue);
            }
            row$.append(td$);
        }
        tb$.append(row$);
    }
}

function toLowerCaseKeys(obj) {
    return Object.keys(obj).reduce(function (accum, key) {
        accum[key.toLowerCase()] = obj[key];
        return accum;
    }, {});
}

function pushCustomAction(customAction) {
    var caLS = window.localStorage.getItem(_customaActionName_BAT_core),
        ca = null;
    if (typeof caLS === 'undefined' || caLS === null || caLS === '') {
        ca = [];
    } else {
        ca = JSON.parse(caLS);
    }
    ca.push(customAction);
    window.localStorage.setItem(_customaActionName_BAT_core, JSON.stringify(ca));
}

function popCustomAction() {
    var caLS = window.localStorage.getItem(_customaActionName_BAT_core),
        ca = null,
        res = null;
    if (typeof caLS === 'undefined' || caLS === null || caLS === '') {
        ca = [];
    } else {
        ca = JSON.parse(caLS);
    }
    if (ca.length > 0) {
        res = JSON.parse(ca[0]);
        ca = ca.slice(1);
    }
    window.localStorage.setItem(_customaActionName_BAT_core, ca);
    return res;
}

function isDebug() {
    return DEBUGJavaScript !== null && typeof DEBUGJavaScript !== 'undefined' && DEBUGJavaScript === true;
}

function isFormacion() {
    return EsFormacionJavaScript !== null && typeof EsFormacionJavaScript !== 'undefined' && EsFormacionJavaScript === true;
}

function getScrType() {
    if (!isDebug()) {
        return '.min';
    } else {
        return '';
    }
}

function isScrolledIntoView(elem) {
    return _isScrolledIntoView_BAT_core(elem);
}

function isScrolledIntoScroll(elem, scroll) {
    return _isScrolledIntoScroll_BAT_core(elem, scroll);
}
},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sync = undefined;
exports.listToSQLFilter = listToSQLFilter;
exports.getRowsFromQueryResult = getRowsFromQueryResult;

require('./BAT.arrayUtils.js');

var _BATDataSyncManager = require('./BAT.data.syncManager.js');

var sync = _interopRequireWildcard(_BATDataSyncManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function listToSQLFilter(lstCod) {
    var res = "";
    $.each(lstCod, function (idEl, el) {
        res += '"' + el + '", ';
    });
    return res.toString().substring(0, res.length - 2);
}
function getRowsFromQueryResult(queryResult) {
    var resRows = [];
    if (queryResult.rows.length > 0) {
        var pns = Object.getOwnPropertyNames(queryResult.rows.item(0));
        $.each(BAT.db.rowsToArray(queryResult.rows), function (idEl, el) {
            r = {};
            $.each(pns, function (idpn, pn) {
                r[pn] = el[pn];
            });
            resRows.push(r);
        });
    }
    return resRows;
}
exports.sync = sync;
},{"./BAT.arrayUtils.js":2,"./BAT.data.syncManager.js":5}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.syncManager = exports.syncObject = exports.objectCache = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./BAT.arrayUtils.js');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _syncManagerStorage_BAT_data_syncManager = 'syncManagerStorage';
var _memTableSyncState_BAT_data_syncManager = function () {
    var _detenido = 'detenido';
    var _enEjecución = 'enEjecución';
    return {
        detenido: function () {
            return _detenido;
        }(),
        enEjecución: function () {
            return _enEjecución;
        }()
    };
}();

var objectCache = exports.objectCache = function () {
    _createClass(objectCache, [{
        key: '_terminate',
        value: function _terminate() {
            this._initialized = null;
            this._objectDictionary = {};
            this._objectArray = [];
        }
    }, {
        key: '_getByKey',
        value: function _getByKey(key) {
            var res = null;
            if (!this._initialized) {
                throw 'State Exception';
            } else {
                res = this._objectDictionary[key.toString()];
                if (typeof res === 'undefined') {
                    res = null;
                }
                return res;
            }
        }
    }, {
        key: '_hasKey',
        value: function _hasKey(key) {
            var res = null;
            if (!this._initialized) {
                throw 'State Exception';
            } else {
                res = this._objectDictionary[key.toString()];
                if (typeof res === 'undefined' || res === null) {
                    res = false;
                } else {
                    res = true;
                }
                return res;
            }
        }
    }, {
        key: '_where',
        value: function _where(filter) {
            var res = null;
            if (!this._initialized) {
                throw 'State Exception';
            } else {
                return this._objectArray.where(filter);
            }
        }
    }, {
        key: '_select',
        value: function _select(expression) {
            var res = null;
            if (!this._initialized) {
                throw 'State Exception';
            } else {
                return this._objectArray.select(expression);
            }
        }
    }, {
        key: '_getObjectKeyVal',
        value: function _getObjectKeyVal(ObjectElement) {
            if (this._objectKey.indexOf(';') === -1) {
                return ObjectElement[this._objectKey];
            } else {
                var res = "";
                var myOb = this;
                var keys = this._objectKey.split(';');
                $.each(keys, function (idEl, el) {
                    res += ObjectElement[el] + (idEl < keys.length - 1 ? ";" : "");
                });
                return res;
            }
        }
    }, {
        key: '_getObjectHasKeys',
        value: function _getObjectHasKeys(ObjectElement) {
            if (this._objectKey.indexOf(';') === -1) {
                return ObjectElement.hasOwnProperty(this._objectKey);
            } else {
                var res = "";
                var myOb = this;
                var keys = this._objectKey.split(';');
                var pos = keys.length - 1;
                while (pos >= 0 && ObjectElement.hasOwnProperty(keys[pos])) {
                    pos--;
                }
                return pos === -1;
            }
        }
    }, {
        key: '_init',
        value: function _init(objectsArray) {
            var myOb = this;
            if (objectsArray === null || typeof objectsArray === 'undefined') {
                throw 'Argument Exception';
            }
            this._terminate();
            if (objectsArray.length > 0) {
                if (!this._getObjectHasKeys(objectsArray[0])) {
                    throw 'Argument Exception';
                } else {
                    this._objectArray = new Array(objectsArray.length);
                    $.each(objectsArray, function (idElem, elem) {
                        myOb._objectDictionary[myOb._getObjectKeyVal(elem)] = elem;
                        myOb._objectArray[idElem] = elem;
                    });
                    this._initialized = true;
                }
            }
        }
    }]);

    function objectCache(objectKey, objectAlias) {
        _classCallCheck(this, objectCache);

        this._initialized = null;
        this._objectDictionary = {};
        this._objectArray = [];
        this._objectKey = objectKey;
        this._objectAlias = objectAlias;
    }

    _createClass(objectCache, [{
        key: 'setReload',
        value: function setReload() {
            return this._terminate();
        }
    }, {
        key: 'getAll',
        value: function getAll() {
            return this._objectArray;
        }
    }, {
        key: 'getByKey',
        value: function getByKey(key) {
            return this._getByKey(key);
        }
    }, {
        key: 'hasKey',
        value: function hasKey(key) {
            return this._hasKey(key);
        }
    }, {
        key: 'init',
        value: function init(objectsArray) {
            return this._init(objectsArray);
        }
    }, {
        key: 'count',
        value: function count() {
            return this._objectArray.length;
        }
    }, {
        key: 'where',
        value: function where(filter) {
            return this._where(filter);
        }
    }, {
        key: 'select',
        value: function select() {
            return this._select.apply(this, arguments);
        }
    }]);

    return objectCache;
}();

var syncObject = exports.syncObject = function () {
    function syncObject(objectKey, objectSyncKey, objectAlias, urlSync, intervalSeconds, useCompression) {
        _classCallCheck(this, syncObject);

        this._objectKey = objectKey;
        this._objectSyncKey = objectSyncKey;
        this._objectAlias = objectAlias;
        this._urlSync = urlSync;
        this._intervalSeconds = intervalSeconds;
        this._cache = new objectCache(objectKey, objectAlias);
        this._useCompression = false;
        if (useCompression !== null && (typeof useCompression === 'undefined' ? 'undefined' : _typeof(useCompression)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && useCompression === true) this._useCompression = true;
    }

    _createClass(syncObject, [{
        key: 'toLocalStorage',
        value: function toLocalStorage() {
            if (this._useCompression === true && (typeof LZString === 'undefined' ? 'undefined' : _typeof(LZString)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined))) {
                localStorage.setItem(_syncManagerStorage_BAT_data_syncManager + this._objectAlias.toString().normalize(), LZString.compress(JSON.stringify(this._cache.getAll())));
            } else {
                localStorage.setItem(_syncManagerStorage_BAT_data_syncManager + this._objectAlias.toString().normalize(), JSON.stringify(this._cache.getAll()));
            }
        }
    }, {
        key: 'fromLocalStorage',
        value: function fromLocalStorage() {
            var tmpData = null;
            if (this._useCompression === true && (typeof LZString === 'undefined' ? 'undefined' : _typeof(LZString)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined))) {
                tmpData = JSON.parse(LZString.decompress(localStorage.getItem(_syncManagerStorage_BAT_data_syncManager + this._objectAlias.toString().normalize())));
            } else {
                tmpData = JSON.parse(localStorage.getItem(_syncManagerStorage_BAT_data_syncManager + this._objectAlias.toString().normalize()));
            }
            if (tmpData !== null && typeof tmpData !== 'undefined') {
                this._cache.init(tmpData);
                tmpData = null;
            }
        }
    }, {
        key: 'objectKey',
        get: function get() {
            return this._objectKey;
        }
    }, {
        key: 'objectSyncKey',
        get: function get() {
            return this._objectSyncKey;
        }
    }, {
        key: 'objectAlias',
        get: function get() {
            return this._objectAlias;
        }
    }, {
        key: 'urlSync',
        get: function get() {
            return this._urlSync;
        }
    }, {
        key: 'intervalSeconds',
        get: function get() {
            return this._intervalSeconds;
        }
    }, {
        key: 'cache',
        get: function get() {
            return this._cache;
        }
    }]);

    return syncObject;
}();

var syncManager = exports.syncManager = function () {
    _createClass(syncManager, [{
        key: '_init',
        value: function _init(reload) {
            if (this._initialized === null || reload === true) {
                var myOb = this;

                $.each(Object.getOwnPropertyNames(this._cacheDic), function (idEl, el) {
                    myOb._cacheDic[el].fromLocalStorage();
                });
            }
        }
    }, {
        key: '_sync',
        value: function _sync(objectAlias) {
            var tmpO = this._cacheDic[objectAlias];
            var maxFecha;
            var myObject = this;
            if (tmpO !== null && typeof tmpO !== 'undefined') {
                this._activeSyncCount++;
                myObject.onSyncStateChange(myObject._activeSyncCount > 0);
                return $.Deferred(function (defS) {
                    $.ajax({
                        type: "POST",
                        url: tmpO.urlSync,
                        data: JSON.stringify({ tabla: objectAlias, desde: null }),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json"
                    }).done(function (data) {
                        tmpO.cache.init(data);
                        tmpO.toLocalStorage();
                        myObject.onNewData(objectAlias);
                        defS.resolve();
                    }).fail(function () {
                        defS.reject();
                    }).always(function () {
                        myObject._activeSyncCount--;
                        myObject.onSyncStateChange(myObject._activeSyncCount > 0);
                    });
                });
            } else {
                throw 'Argument Exception';
            }
        }
    }, {
        key: '_addSyncObjects',
        value: function _addSyncObjects(syncObjectsArray) {
            var myObject = this;
            var op = Object.getOwnPropertyNames(this);
            $.each(syncObjectsArray, function (idEl, el) {
                myObject._cacheDic[el.objectAlias] = el;

                if (op.indexOf(el.objectAlias) === -1) {
                    myObject[el.objectAlias] = el.cache;
                }
            });
        }
    }]);

    function syncManager(syncObjectsArray) {
        _classCallCheck(this, syncManager);

        this._initialized = null;
        this._state = _memTableSyncState_BAT_data_syncManager.detenido;
        this._cacheDic = {};
        this._activeSyncCount = 0;
        this._addSyncObjects(syncObjectsArray);
    }

    _createClass(syncManager, [{
        key: 'init',
        value: function init(reload) {
            return this._init(reload);
        }
    }, {
        key: 'sync',
        value: function sync(objectAlias) {
            return this._sync(objectAlias);
        }
    }]);

    return syncManager;
}();

syncManager.prototype.onStart = function () {
    var _event = document.createEvent("CustomEvent");
    _event.initCustomEvent('syncManager:Started', false, false, {});
    document.dispatchEvent(_event);
};
syncManager.prototype.onStop = function () {
    var _event = document.createEvent("CustomEvent");
    _event.initCustomEvent('syncManager:Stoped', false, false, {});
    document.dispatchEvent(_event);
};
syncManager.prototype.onNewData = function (alias) {
    var _event = document.createEvent("CustomEvent");
    _event.initCustomEvent('syncManager:NewData', false, false, { objectAlias: alias });
    document.dispatchEvent(_event);
};
syncManager.prototype.onSyncStateChange = function (isSynchronizing) {
    var _event = document.createEvent("CustomEvent");
    _event.initCustomEvent('syncManager:SyncStateChange', false, false, { isSynchronizing: isSynchronizing });
    document.dispatchEvent(_event);
};
},{"./BAT.arrayUtils.js":2}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BATCore = require('./BAT.core.js');

var core = _interopRequireWildcard(_BATCore);

var _BATStringsUtils = require('./BAT.stringsUtils.js');

var strings = _interopRequireWildcard(_BATStringsUtils);

var _BATLocalization = require('./BAT.localization.js');

var localization = _interopRequireWildcard(_BATLocalization);

var _BATMessageDialog = require('./BAT.messageDialog.js');

var messageDialog = _interopRequireWildcard(_BATMessageDialog);

var _BATLogin = require('./BAT.login.js');

var login = _interopRequireWildcard(_BATLogin);

var _BATApplication = require('./BAT.application.js');

var _BATArrayUtils = require('./BAT.arrayUtils.js');

var arrays = _interopRequireWildcard(_BATArrayUtils);

var _BATData = require('./BAT.data.js');

var data = _interopRequireWildcard(_BATData);

var _BATLoginDialog = require('./BAT.loginDialog.js');

var loginDialog = _interopRequireWildcard(_BATLoginDialog);

var _BATRestLoginDialog = require('./BAT.restLoginDialog.js');

var restLoginDialog = _interopRequireWildcard(_BATRestLoginDialog);

var _BATProgressDialog = require('./BAT.progressDialog.js');

var progressDialog = _interopRequireWildcard(_BATProgressDialog);

var _BATNotifications = require('./BAT.notifications.js');

var notifications = _interopRequireWildcard(_BATNotifications);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bat = function () {
    function bat() {
        _classCallCheck(this, bat);
    }

    _createClass(bat, null, [{
        key: 'showError',
        value: function showError() {
            return messageDialog.showError.apply(undefined, arguments);
        }
    }, {
        key: 'showInfo',
        value: function showInfo() {
            return messageDialog.showInfo.apply(undefined, arguments);
        }
    }, {
        key: 'showWarning',
        value: function showWarning() {
            return messageDialog.showWarning.apply(undefined, arguments);
        }
    }, {
        key: 'showConfirm',
        value: function showConfirm() {
            return messageDialog.showConfirm.apply(undefined, arguments);
        }
    }, {
        key: 'showNotification',
        value: function showNotification() {
            return notifications.showInfo.apply(undefined, arguments);
        }
    }, {
        key: 'core',
        get: function get() {
            return core;
        }
    }, {
        key: 'strings',
        get: function get() {
            return strings;
        }
    }, {
        key: 'lang',
        get: function get() {
            return localization;
        }
    }, {
        key: 'login',
        get: function get() {
            return login;
        }
    }, {
        key: 'app',
        get: function get() {
            return _BATApplication.application;
        }
    }, {
        key: 'data',
        get: function get() {
            return data;
        }
    }, {
        key: 'loginDialog',
        get: function get() {
            return loginDialog;
        }
    }, {
        key: 'restLoginDialog',
        get: function get() {
            return restLoginDialog;
        }
    }, {
        key: 'progressDialog',
        get: function get() {
            return progressDialog;
        }
    }]);

    return bat;
}();

;
function _initModule_BAT() {
    if (window.ç === undefined) {
        window.ç = bat;
    }
    if (window.BAT === undefined) {
        window.BAT = bat;
    }
}
exports.default = bat;

_initModule_BAT();
module.exports = exports['default'];
},{"./BAT.application.js":1,"./BAT.arrayUtils.js":2,"./BAT.core.js":3,"./BAT.data.js":4,"./BAT.localization.js":7,"./BAT.login.js":8,"./BAT.loginDialog.js":9,"./BAT.messageDialog.js":10,"./BAT.notifications.js":11,"./BAT.progressDialog.js":12,"./BAT.restLoginDialog.js":13,"./BAT.stringsUtils.js":14}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.current = exports.list = undefined;
exports.getFromURL = getFromURL;
exports.get = get;
exports.load = load;
exports.change = change;

require('./BAT.stringsUtils.js');

var _localStorageName_BAT_localization = 'BATlocalization';
var _changeLang_BAT_localization = function _changeLang_BAT_localization(newLang, event) {
    var nl = '/es';
    if (newLang.toUpperCase() === 'ES') {
        nl = '/es';
    } else if (newLang.toUpperCase() === 'EN') {
        nl = '/en';
    } else if (newLang.toUpperCase() === 'DE') {
        nl = '/de';
    }
    window.location.href = nl;
    event.preventDefault();
};
var _loadLang_BAT_localization = function _loadLang_BAT_localization(i18nPath) {
    return _loadLangImp_BAT_localization(_getURLLang_BAT_localization().lang, i18nPath);
};
var _loadLangImp_BAT_localization = function _loadLangImp_BAT_localization(lang, i18nPath) {
    return $.Deferred(function (defL) {
        var s = [];

        s.push($.ajax({ url: i18nPath.toString().trim('/') + '/i18n.' + lang + '.min.js', dataType: 'script' }));

        $.when.apply($, s).done(function () {
            defL.resolve();
        }).fail(function () {
            defL.reject();
        });
    });
};
var _getURLLangRes_BAT_localization = function _getURLLangRes_BAT_localization(lang, isDefault) {
    return { lang: lang, isDefault: isDefault };
};
var _getURLLang_BAT_localization = function _getURLLang_BAT_localization() {
    var pp = window.location.pathname.toString().split('/');
    if (pp.length > 1 && pp[1] !== '' && typeof pp[1] !== 'undefined') {
        if (pp[1].toString().toUpperCase() === 'EN') {
            return _getURLLangRes_BAT_localization('en-GB', false);
        } else if (pp[1].toString().toUpperCase() === 'DE') {
            return _getURLLangRes_BAT_localization('de-DE', false);
        } else if (pp[1].toString().toUpperCase() === 'ES') {
            return _getURLLangRes_BAT_localization('es-ES', false);
        } else {
            if (pp.length > 1 && pp[pp.length - 1] !== '' && typeof pp[pp.length - 1] !== 'undefined') {
                if (pp[pp.length - 1].toString().toUpperCase() === 'EN') {
                    return _getURLLangRes_BAT_localization('en-GB', false);
                } else if (pp[pp.length - 1].toString().toUpperCase() === 'DE') {
                    return _getURLLangRes_BAT_localization('de-DE', false);
                } else if (pp[pp.length - 1].toString().toUpperCase() === 'ES') {
                    return _getURLLangRes_BAT_localization('es-ES', false);
                } else {
                    return _getURLLangRes_BAT_localization('es-ES', true);
                }
            } else {
                return _getURLLangRes_BAT_localization('es-ES', true);
            }
        }
    } else {
        return _getURLLangRes_BAT_localization('es-ES', true);
    }
};
var _getCurrentLang_BAT_localization = function _getCurrentLang_BAT_localization() {
    var urlCurrent = _getURLLang_BAT_localization(),
        lstCurrent = localStorage.getItem(_localStorageName_BAT_localization);

    if (urlCurrent.isDefault === true && lstCurrent !== null && typeof lstCurrent !== 'undefined') {
        return lstCurrent;
    } else {
        localStorage.setItem(_localStorageName_BAT_localization, urlCurrent.lang);
    }
    return localStorage.getItem(_localStorageName_BAT_localization);
};
var list = exports.list = {};
var current = exports.current = undefined;
function getFromURL() {
    return _getURLLang_BAT_localization();
}
function get() {
    return _getCurrentLang_BAT_localization();
}
function load(i18nPath) {
    return _loadLang_BAT_localization(i18nPath);
}
function change(newLang, event) {
    return _changeLang_BAT_localization(newLang, event);
}
},{"./BAT.stringsUtils.js":14}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.login = login;
exports.logueado = logueado;
exports.checkLogueado = checkLogueado;
exports.getBearerToken = getBearerToken;
exports.getBearerTokenObject = getBearerTokenObject;
exports.getValidation = getValidation;
exports.logout = logout;
exports.resetPassword = resetPassword;
exports.activarResetPassword = activarResetPassword;
exports.activarWelcome = activarWelcome;
exports.cancelarResetPassword = cancelarResetPassword;
exports.cancelarWelcome = cancelarWelcome;
exports.reseteandoPassword = reseteandoPassword;
exports.welcoming = welcoming;
exports.changePassword = changePassword;
exports.forgotPassword = forgotPassword;
exports.isValidResetToken = isValidResetToken;

require("./BAT.core.js");

var _loginTokenStorageKey_BAT_login = "BATLoginToken";
var _loginValidationStorageKey_BAT_login = "BATLoginValidation";
var _loginValidationTypeStorageKey_BAT_login = "BATLoginValidationType";
var _loginValidationTypeResetPassword_BAT_login = "vtResetPassword";
var _loginValidationTypeWelcome_BAT_login = "vtWelcome";
var _refreshTokenRequestTimeoutMilliseconds_BAT_login = 5000;
var _refreshTokenWaitUntilSeconds_BAT_login = 60;
var _refreshTokenAttempts_BAT_login = 5;
var _currentToken_BAT_login = null;
var _currentValidation_BAT_login = null;
var _currentValidationType_BAT_login = null;
var _intervaloRenovacion_BAT_login = null;
var _guardarLoginToken_BAT_login = function _guardarLoginToken_BAT_login(token) {
    localStorage.setItem(_loginTokenStorageKey_BAT_login, token);
    _currentToken_BAT_login = token;
    _updateRefreshInterval_BAT_login();
};
var _clearUpdateRefreshInterval_BAT_login = function _clearUpdateRefreshInterval_BAT_login() {
    if (_intervaloRenovacion_BAT_login !== null) clearInterval(_intervaloRenovacion_BAT_login);
};
var _updateRefreshInterval_BAT_login = function _updateRefreshInterval_BAT_login() {
    _clearUpdateRefreshInterval_BAT_login();

    var tParts = _getBearerTokenObject_BAT_login(_currentToken_BAT_login);
    if (tParts.payload.exp !== null && _typeof(tParts.payload.exp) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        var caduca = new Date(tParts.payload.exp * 1000).getTime();
        var waitMinutes = (caduca - Date.now() - _refreshTokenWaitUntilSeconds_BAT_login * 1000) / 1000 / 60;
        _intervaloRenovacion_BAT_login = setInterval(function () {
            _clearUpdateRefreshInterval_BAT_login();
            _tryRefreshToken_BAT_login(caduca);
        }, waitMinutes * 60 * 1000);
    }
};
var _login_BAT_login = function _login_BAT_login(usuario, clave, rememberMe) {
    return $.Deferred(function (defL) {
        if (usuario.isNullOrWhitespace() || clave.isNullOrWhitespace()) {
            defL.reject("Invalid Arguments");
        } else {
            $.ajax({
                type: "POST",
                url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/authenticate",
                data: JSON.stringify({ Username: usuario, Password: clave, RememberMe: rememberMe || false }),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }).done(function (data) {
                _guardarLoginToken_BAT_login(data);
                defL.resolve();
            }).fail(function (error) {
                defL.reject(error);
            });
        }
    });
};
var _tryRefreshTokenImp_BAT_login = function _tryRefreshTokenImp_BAT_login(def, intento, caduca, ultimoError) {
    if (caduca > Date.now() && _refreshTokenAttempts_BAT_login > intento) {
        $.ajax({
            type: "POST",
            url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/refresh",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            timeout: _refreshTokenRequestTimeoutMilliseconds_BAT_login
        }).done(function (data) {
            _guardarLoginToken_BAT_login(data);
            def.resolve();
        }).fail(function (error) {
            var errorMsg = 'Error desconocido renovando login';
            if (error !== null && (typeof error === "undefined" ? "undefined" : _typeof(error)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) && error.responseJSON !== null && _typeof(error.responseJSON) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
                errorMsg = error.responseJSON.Message;
            }

            setTimeout(function () {
                _tryRefreshTokenImp_BAT_login(def, intento + 1, caduca, errorMsg);
            }, _refreshTokenWaitUntilSeconds_BAT_login * 1000 / _refreshTokenAttempts_BAT_login);
        });
    } else {
        def.reject(ultimoError);
    }
};
var _tryRefreshToken_BAT_login = function _tryRefreshToken_BAT_login(caduca) {
    return $.Deferred(function (defL) {
        _tryRefreshTokenImp_BAT_login(defL, 0, caduca, '');
    });
};
var _logueado_BAT_login = function _logueado_BAT_login() {
    return _currentToken_BAT_login !== null && typeof _currentToken_BAT_login !== 'undefined';
};
var _checkLogueado_BAT_login = function _checkLogueado_BAT_login() {
    return $.Deferred(function (def) {
        if (_currentToken_BAT_login !== null && typeof _currentToken_BAT_login !== 'undefined') {
            $.ajax({
                type: "GET",
                url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/echouser" }).done(function (data) {
                var res = data !== null && data.isAuthenticated !== null && typeof data.isAuthenticated !== 'undefined' && (data.isAuthenticated === true || data.isAuthenticated.toString().toUpperCase() === 'TRUE' || data.isAuthenticated.toString().toUpperCase() === '1');
                if (res === true) {
                    _updateRefreshInterval_BAT_login();
                    def.resolve(true);
                } else {
                    def.resolve(false);
                }
            }).fail(function (error) {
                def.reject(error);
            });
        } else {
            def.reject();
        }
    });
};
var _getValidation_BAT_login = function _getValidation_BAT_login() {
    if (_currentValidation_BAT_login !== null && typeof _currentValidation_BAT_login !== 'undefined') {
        return _currentValidation_BAT_login;
    } else {
        if (localStorage.getItem(_loginValidationStorageKey_BAT_login) !== null && typeof localStorage.getItem(_loginValidationStorageKey_BAT_login) !== 'undefined') {
            _currentValidation_BAT_login = localStorage.getItem(_loginValidationStorageKey_BAT_login);
            return _currentValidation_BAT_login;
        } else {
            return null;
        }
    }
};
var _getValidationType_BAT_login = function _getValidationType_BAT_login() {
    if (_currentValidationType_BAT_login !== null && typeof _currentValidationType_BAT_login !== 'undefined') {
        return _currentValidationType_BAT_login;
    } else {
        if (localStorage.getItem(_loginValidationTypeStorageKey_BAT_login) !== null && typeof localStorage.getItem(_loginValidationTypeStorageKey_BAT_login) !== 'undefined') {
            _currentValidationType_BAT_login = localStorage.getItem(_loginValidationTypeStorageKey_BAT_login);
            return _currentValidationType_BAT_login;
        } else {
            return null;
        }
    }
};
var _getBearerToken_BAT_login = function _getBearerToken_BAT_login() {
    if (_logueado_BAT_login()) {
        return _currentToken_BAT_login;
    } else {
        if (localStorage.getItem(_loginTokenStorageKey_BAT_login) !== null && typeof localStorage.getItem(_loginTokenStorageKey_BAT_login) !== 'undefined') {
            _currentToken_BAT_login = localStorage.getItem(_loginTokenStorageKey_BAT_login);
            return _currentToken_BAT_login;
        } else {
            return null;
        }
    }
};
var _getBearerTokenObject_BAT_login = function _getBearerTokenObject_BAT_login() {
    var bt = _getBearerToken_BAT_login();
    if (bt !== null) {
        var parts = bt.split('.');
        return {
            header: JSON.parse(atob(parts[0])),
            payload: JSON.parse(atob(parts[1])),
            signature: parts[2]
        };
    } else {
        return null;
    }
};
var _logout_BAT_login = function _logout_BAT_login() {
    localStorage.removeItem(_loginTokenStorageKey_BAT_login);
    _currentToken_BAT_login = null;
    _clearUpdateRefreshInterval_BAT_login();
};
var _resetPassword_BAT_login = function _resetPassword_BAT_login(nuevaClave, validacion) {
    return $.Deferred(function (defL) {
        if (validacion.isNullOrWhitespace() || nuevaClave.isNullOrWhitespace()) {
            def.reject("Invalid Arguments");
        } else {
            $.ajax({
                type: "POST",
                url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/passwordreset",
                data: JSON.stringify({ Username: '', Password: '', New_password: nuevaClave, Validation: validacion }),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }).done(function (data) {
                _guardarLoginToken_BAT_login(data);
                _currentValidation_BAT_login = null;
                _currentValidationType_BAT_login = null;
                defL.resolve();
            }).fail(function () {
                defL.reject();
            });
        }
    });
};
var _activarResetPassword_BAT_login = function _activarResetPassword_BAT_login(validacion) {
    _currentValidation_BAT_login = validacion;
    _currentValidationType_BAT_login = _loginValidationTypeResetPassword_BAT_login;
    localStorage.setItem(_loginValidationStorageKey_BAT_login, validacion);
    localStorage.setItem(_loginValidationTypeStorageKey_BAT_login, _loginValidationTypeResetPassword_BAT_login);
};
var _activarWelcome_BAT_login = function _activarWelcome_BAT_login(validacion) {
    _currentValidation_BAT_login = validacion;
    _currentValidationType_BAT_login = _loginValidationTypeWelcome_BAT_login;
    localStorage.setItem(_loginValidationStorageKey_BAT_login, validacion);
    localStorage.setItem(_loginValidationTypeStorageKey_BAT_login, _loginValidationTypeWelcome_BAT_login);
};
var _cancelarResetPassword_BAT_login = function _cancelarResetPassword_BAT_login() {
    _cancelarResetValidation_BAT_login();
};
var _cancelarWelcome_BAT_login = function _cancelarWelcome_BAT_login() {
    _cancelarResetValidation_BAT_login();
};
var _cancelarResetValidation_BAT_login = function _cancelarResetValidation_BAT_login() {
    _currentValidation_BAT_login = null;
    _currentValidationType_BAT_login = null;
    localStorage.removeItem(_loginValidationStorageKey_BAT_login);
    localStorage.removeItem(_loginValidationTypeStorageKey_BAT_login);
};
var _reseteandoPassword_BAT_login = function _reseteandoPassword_BAT_login() {
    if (_currentValidation_BAT_login !== null && typeof _currentValidation_BAT_login !== 'undefined' && _currentValidationType_BAT_login !== null && typeof _currentValidationType_BAT_login !== 'undefined' && _currentValidationType_BAT_login === _loginValidationTypeResetPassword_BAT_login) {
        return true;
    } else {
        var tmpVal = localStorage.getItem(_loginValidationStorageKey_BAT_login);
        var tmpValType = localStorage.getItem(_loginValidationTypeStorageKey_BAT_login);
        if (tmpVal !== null && typeof tmpVal !== 'undefined' && tmpValType !== null && typeof tmpValType !== 'undefined' && tmpValType === _loginValidationTypeResetPassword_BAT_login) {
            _currentValidation_BAT_login = tmpVal;
            _currentValidationType_BAT_login = _loginValidationTypeResetPassword_BAT_login;
            return true;
        } else {
            return false;
        }
    }
};
var _welcoming_BAT_login = function _welcoming_BAT_login() {
    if (_currentValidation_BAT_login !== null && typeof _currentValidation_BAT_login !== 'undefined' && _currentValidationType_BAT_login !== null && typeof _currentValidationType_BAT_login !== 'undefined' && _currentValidationType_BAT_login === _loginValidationTypeWelcome_BAT_login) {
        return true;
    } else {
        var tmpVal = localStorage.getItem(_loginValidationStorageKey_BAT_login);
        var tmpValType = localStorage.getItem(_loginValidationTypeStorageKey_BAT_login);
        if (tmpVal !== null && typeof tmpVal !== 'undefined' && tmpValType !== null && typeof tmpValType !== 'undefined' && tmpValType === _loginValidationTypeWelcome_BAT_login) {
            _currentValidation_BAT_login = tmpVal;
            _currentValidationType_BAT_login = _loginValidationTypeWelcome_BAT_login;
            return true;
        } else {
            return false;
        }
    }
};
var _changePassword_BAT_login = function _changePassword_BAT_login(usuario, clave, nuevaClave, validacion) {
    return $.Deferred(function (defL) {
        if (usuario.isNullOrWhitespace() || nuevaClave.isNullOrWhitespace()) {
            def.reject("Invalid Arguments");
        } else {
            $.ajax({
                type: "POST",
                url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/passwordchange",
                data: JSON.stringify({ Username: usuario, Password: clave, New_password: nuevaClave, Validation: validacion }),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }).done(function (data) {
                _guardarLoginToken_BAT_login(data);
                _currentValidation_BAT_login = null;
                _currentValidationType_BAT_login = null;
                defL.resolve();
            }).fail(function () {
                defL.reject();
            });
        }
    });
};
var _forgotPassword_BAT_login = function _forgotPassword_BAT_login(usuario) {
    return $.Deferred(function (defL) {
        if (usuario.isNullOrWhitespace()) {
            defL.reject("Invalid Arguments");
        } else {
            $.ajax({
                type: "POST",
                url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/forgotpassword",
                data: JSON.stringify({ Username: usuario }),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }).done(function (data) {
                defL.resolve();
            }).fail(function () {
                defL.reject();
            });
        }
    });
};
var isValidResetToken_BAT_login = function isValidResetToken_BAT_login(validacion) {
    return $.Deferred(function (defL) {
        if (validacion.isNullOrWhitespace()) {
            defL.reject("Invalid Arguments");
        } else {
            $.ajax({
                type: "POST",
                url: BAT.core.getUrlWebApi().trimEnd("/") + "/Login/checkResetToken",
                data: JSON.stringify(validacion),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }).done(function (data) {
                defL.resolve();
            }).fail(function () {
                defL.reject();
            });
        }
    });
};
function login(usuario, clave, recuerdame) {
    return _login_BAT_login(usuario, clave, recuerdame);
}
function logueado() {
    return _logueado_BAT_login();
}
function checkLogueado() {
    return _checkLogueado_BAT_login();
}
function getBearerToken() {
    return _getBearerToken_BAT_login();
}
function getBearerTokenObject() {
    return _getBearerTokenObject_BAT_login();
}
function getValidation() {
    return _getValidation_BAT_login();
}
function logout() {
    return _logout_BAT_login();
}
function resetPassword(nuevaClave, validacion) {
    return _resetPassword_BAT_login(nuevaClave, validacion);
}
function activarResetPassword(validacion) {
    return _activarResetPassword_BAT_login(validacion);
}
function activarWelcome(validacion) {
    return _activarWelcome_BAT_login(validacion);
}
function cancelarResetPassword() {
    return _cancelarResetPassword_BAT_login();
}
function cancelarWelcome() {
    return _cancelarWelcome_BAT_login();
}
function reseteandoPassword() {
    return _reseteandoPassword_BAT_login();
}
function welcoming() {
    return _welcoming_BAT_login();
}
function changePassword(usuario, clave, nuevaClave, validacion) {
    return _changePassword_BAT_login(usuario, clave, nuevaClave, validacion);
}
function forgotPassword(usuario) {
    return _forgotPassword_BAT_login(usuario);
}
function isValidResetToken(validacion) {
    return isValidResetToken_BAT_login(validacion);
}
},{"./BAT.core.js":3}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.execute = execute;
exports.executeForgot = executeForgot;

require('./BAT.localization.js');

var _state_BAT_loginDialog = null;
var _showingState_BAT_loginDialog = null;
var _resolveData_BAT_loginDialog = null;

var _htmlDiagContent_BAT_loginDialog = "<div class=\"modal fade\" id=\"loginModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"loginModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\"> \
    <div class=\"modal-dialog\" role=\"document\"> \
        <div class=\"modal-content\"> \
            <div class=\"modal-header\"> \
                <h5 class=\"modal-title\" id=\"loginModalLabel\">Iniciar sesión</h5> \
                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"> \
                    <span aria-hidden=\"true\">&times;</span> \
                </button> \
            </div> \
            <div class=\"modal-body\"> \
                <form> \
                    <div class=\"form-group\"> \
                        <div class=\"container\"> \
                            <div class=\"row\"> \
                                <div class=\"col-sm-3\"> \
                                   <label for=\"login-name\" class=\"col-form-label\">Dirección de e-mail</label> \
                                </div> \
                            </div> \
                        </div> \
                        <input type=\"text\" class=\"form-control\" id=\"login-name\"> \
                    </div> \
                    <div class=\"form-group\" id=\"login-pass-cntr\"> \
                        <div class=\"container\"> \
                            <div class=\"row\"> \
                                <div class=\"col-sm-3\"> \
                                    <label for=\"login-pass\" class=\"col-form-label\">Contraseña</label> \
                                </div> \
                                <div class=\"col-sm-9 text-right login-forgot-cntr\"> \
                                    <label class=\"col-form-label\"> \
                                        <a href=\"#\" class=\"\" id=\"login-forgot\" tabindex=\"-1\">¿Has olvidado la contraseña?</a> \
                                    </label> \
                                </div> \
                            </div> \
                        </div> \
                        <input type=\"password\" class=\"form-control\" id=\"login-pass\"> \
                        <div class=\"form-check\"> \
                          <input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"login-rememberme\" tabindex=\"-1\"> \
                          <label class=\"form-check-label\" for=\"login-rememberme\"> \
                            Recuérdame \
                          </label> \
                        </div> \
                    </div> \
                    <div class=\"alert alert-warning\" role=\"alert\" id=\"login-err\"> \
                      A simple warning alert—check it out! \
                    </div> \
                </form> \
            </div> \
            <div class=\"modal-footer\"> \
                <button type=\"button\" class=\"btn btn-primary\">Iniciar sesión</button> \
            </div> \
        </div> \
    </div> \
</div>";
var _resetState_BAT_loginDialog = function _resetState_BAT_loginDialog() {
    _showingState_BAT_loginDialog = false;
    _resolveData_BAT_loginDialog = null;
};
var _init_BAT_loginDialog = function _init_BAT_loginDialog() {
    if ($('#loginModal').length === 0) {
        var temp = {};

        $.extend(true, temp, {
            "es-ES": {
                BAT: {
                    loginDialog: {
                        login: 'Iniciar sesión',
                        renewRequest: 'Solicitar nueva contraseña',
                        email: 'Dirección de e-mail',
                        pass: 'Contraseña',
                        forgot: '¿Has olvidado la contraseña?',
                        error: 'Dirección de e-mail o contraseña incorrectos',
                        errorState: 'Usuario bloqueado, contacte con nosotros, por favor',
                        rememberMe: 'Recuérdame'
                    }
                }
            },
            "en-GB": {
                BAT: {
                    loginDialog: {
                        login: 'Sign in',
                        renewRequest: 'Request new password',
                        email: 'Email',
                        pass: 'Password',
                        forgot: 'Forgot your password?',
                        error: 'Wrong email or password',
                        errorState: 'Locked user, please contact us',
                        rememberMe: 'Keep me signed in'
                    }
                }
            },
            "de-DE": {
                BAT: {
                    loginDialog: {
                        login: 'Anmelden ',
                        renewRequest: 'Request new password',
                        email: 'E-Mail-Adresse',
                        pass: 'Passwort',
                        forgot: 'Passwort vergessen',
                        error: 'Falsche Email oder Passwort',
                        errorState: 'Gesperrter Benutzer, bitte kontaktieren Sie uns',
                        rememberMe: 'Angemeldet bleiben'
                    }
                }
            }
        }, BAT.lang.list);
        BAT.lang.list = temp;
        $("body").append(_htmlDiagContent_BAT_loginDialog);

        var _getUIData = function _getUIData(esForgot) {
            return {
                login: $('#login-name').val(),
                pass: $('#login-pass').val(),
                forgot: esForgot === true,
                rememberMe: $('#login-rememberme').is(':checked')
            };
        };
        $('#loginModal button.btn-primary').on('click tap', function (event) {
            event.preventDefault();
            event.stopPropagation();
            _resolveData_BAT_loginDialog = _getUIData(false);
            $('#loginModal').modal('hide');
        });
        $('#login-forgot').on('click tap', function (event) {
            event.preventDefault();
            event.stopPropagation();
            _resolveData_BAT_loginDialog = _getUIData(true);
            $('#loginModal').modal('hide');
        });
        $('#loginModal').on('hidden.bs.modal', function (e) {
            var resultado = JSON.parse(JSON.stringify(_resolveData_BAT_loginDialog));
            _resetState_BAT_loginDialog();
            if (typeof resultado !== 'undefined' && resultado !== null) {
                _state_BAT_loginDialog.resolve(resultado);
            } else {
                _state_BAT_loginDialog.reject();
            }
        });
        $('#loginModal form').keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                event.stopPropagation();
                setTimeout(function () {
                    $('#loginModal button.btn-primary').click();
                }, 0);
                return false;
            }
        });
    }
};
var _execute_BAT_loginDialog = function _execute_BAT_loginDialog(isError, isForgot, isLock) {
    _init_BAT_loginDialog();
    if (_showingState_BAT_loginDialog === null || _showingState_BAT_loginDialog === false) {
        _showingState_BAT_loginDialog = true;
        _state_BAT_loginDialog = $.Deferred(function (def) {
            if (isForgot === true) {
                $('#loginModalLabel').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.renewRequest);
                $('#loginModal button.btn-primary').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.renewRequest);
            } else {
                $('#loginModalLabel').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.login);
                $('#loginModal button.btn-primary').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.login);
            }
            $('#loginModal label[for="login-name"').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.email);
            $('#loginModal label[for="login-pass"').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.pass);
            $('#login-forgot').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.forgot);
            $('[for="login-rememberme"]').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.rememberMe);
            if (isLock === true) {
                $('#login-err').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.errorState);
            } else {
                $('#login-err').text(BAT.lang.list[BAT.lang.current].BAT.loginDialog.error);
            }
            if (isError === true) {
                $('#login-err').show();
            } else {
                $('#login-err').hide();
            }
            if (isForgot === true) {
                $('#login-pass-cntr').hide();
            } else {
                $('#login-pass-cntr').show();
            }
            $('#loginModal').modal('show');
        });
        return _state_BAT_loginDialog;
    } else {
        return $.Deferred(function (def) {
            def.reject('State Error. El diálogo ya se encuentra visible ');
        });
    }
};
function execute(previousError, isLockError) {
    return _execute_BAT_loginDialog(previousError, false, isLockError);
};
function executeForgot(previousError, isLockError) {
    return _execute_BAT_loginDialog(previousError, true, isLockError);
};
},{"./BAT.localization.js":7}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showError = showError;
exports.showInfo = showInfo;
exports.showWarning = showWarning;
exports.showConfirm = showConfirm;

require('./BAT.localization.js');

var _htmlDiagContent_BAT_messageDialog = "<div class=\"modal fade\" id=\"msgModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"msgModalLabel\" data-backdrop=\"static\" data-keyboard=\"false\"> \
  <div class=\"modal-dialog\" role=\"document\"> \
    <div class=\"modal-content\"> \
      <div class=\"modal-header\"> \
        <h4 class=\"modal-title\" id=\"msgModalLabel\">New message</h4> \
        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> \
      </div> \
      <div class=\"modal-body\" id=\"msgModalBody\"> \
      </div> \
      <div class=\"modal-footer\"> \
        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" id=\"msgModalClose\">Close</button> \
        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" id=\"msgModalAccept\">Confirmar</button> \
      </div> \
    </div> \
  </div> \
</div>";
var _init_BAT_messageDialog = function _init_BAT_messageDialog() {
    if ($('#msgModal').length === 0) {
        var temp = {};
        $.extend(true, temp, BAT.lang.list, {
            "es-ES": {
                BAT: {
                    messageDialog: {
                        error: 'Error',
                        warning: '¡Atención!',
                        info: 'Información',
                        close: 'Cerrar',
                        confirm: 'Confirmar'
                    }
                }
            },
            "en-GB": {
                BAT: {
                    messageDialog: {
                        error: 'Error',
                        warning: 'Warning!',
                        info: 'Info.',
                        close: 'Close',
                        confirm: 'Confirm'
                    }
                }
            },
            "de-DE": {
                BAT: {
                    messageDialog: {
                        error: 'Fehler',
                        warning: 'Warnung!',
                        info: 'Information',
                        close: 'Schließen',
                        confirm: 'Bestätige'
                    }
                }
            }
        });
        BAT.lang.list = temp;
        $("body").append(_htmlDiagContent_BAT_messageDialog);
    }
};
var _showImp_BAT_messageDialog = function _showImp_BAT_messageDialog(header, headerClass, body, isConfirm) {
    _init_BAT_messageDialog();
    $('#msgModalLabel').text(header);
    $('#msgModalLabel').parent().removeClass('bg-danger').removeClass('bg-success').removeClass('bg-warning').addClass(headerClass);
    $('#msgModalBody').html(body);
    $('#msgModalClose').text(BAT.lang.list[BAT.lang.current].BAT.messageDialog.close);
    $('#msgModalAccept').text(BAT.lang.list[BAT.lang.current].BAT.messageDialog.confirm);
    if (isConfirm) {
        $('#msgModalAccept').show();
        $('#messageModal').attr('data-backdrop', 'static').attr('data-keyboard', 'false');
    } else {
        $('#msgModalAccept').hide();
        $('#messageModal').removeAttr('data-backdrop').removeAttr('data-keyboard');
    }
    $('#msgModal').modal('show');
};
var _showError_BAT_messageDialog = function _showError_BAT_messageDialog(body) {
    _init_BAT_messageDialog();
    _showImp_BAT_messageDialog(BAT.lang.list[BAT.lang.current].BAT.messageDialog.error, 'bg-danger', body, false);
};
var _showInfo_BAT_messageDialog = function _showInfo_BAT_messageDialog(body) {
    return $.Deferred(function (def) {
        _init_BAT_messageDialog();
        var resIsOk = null;
        $('#msgModalAccept').one('tap click', function (e) {
            resIsOk = true;
        });
        $('#msgModalClose').one('tap click', function (e) {
            resIsOk = false;
        });
        _showImp_BAT_messageDialog(BAT.lang.list[BAT.lang.current].BAT.messageDialog.info, 'bg-success', body, false);
        $('#msgModal').one('hidden.bs.modal', function (e) {
            def.resolve(resIsOk);
        });
    });
};
var _showWarning_BAT_messageDialog = function _showWarning_BAT_messageDialog(body) {
    return $.Deferred(function (def) {
        _init_BAT_messageDialog();
        var resIsOk = null;
        $('#msgModalAccept').one('tap click', function (e) {
            resIsOk = true;
        });
        $('#msgModalClose').one('tap click', function (e) {
            resIsOk = false;
        });
        _showImp_BAT_messageDialog(BAT.lang.list[BAT.lang.current].BAT.messageDialog.warning, 'bg-warning', body, false);
        $('#msgModal').one('hidden.bs.modal', function (e) {
            def.resolve(resIsOk);
        });
    });
};
var _showConfirm_BAT_messageDialog = function _showConfirm_BAT_messageDialog(body) {
    return $.Deferred(function (def) {
        _init_BAT_messageDialog();
        var resIsOk = null;
        $('#msgModalAccept').one('tap click', function (e) {
            resIsOk = true;
        });
        $('#msgModalClose').one('tap click', function (e) {
            resIsOk = false;
        });
        _showImp_BAT_messageDialog(BAT.lang.list[BAT.lang.current].BAT.messageDialog.confirm, 'bg-warning', body, true);
        $('#msgModal').one('hidden.bs.modal', function (e) {
            def.resolve(resIsOk);
        });
    });
};
function showError(errorMessage) {
    return _showError_BAT_messageDialog(errorMessage);
};
function showInfo(infoMessage) {
    return _showInfo_BAT_messageDialog(infoMessage);
};
function showWarning(warningMessage) {
    return _showWarning_BAT_messageDialog(warningMessage);
};
function showConfirm(warningMessage) {
    return _showConfirm_BAT_messageDialog(warningMessage);
};
},{"./BAT.localization.js":7}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.showInfo = showInfo;

require("./BAT.localization.js");

var _htmlToastsContainer_BAT_notifications = "<div aria-live=\"polite\" aria-atomic=\"true\" id=\"batToastsCntr\" style=\"z-index: 1070; position: fixed; top: 0; right: 0; min-height: 200px; min-width: 320px; pointer-events: none;\"> \
  <div class=\"batToastsCntrAbs\" style=\"position: absolute; top: 0; right: 0;\"> \
  </div> \
</div>",
    _htmlToast_BAT_notifications = "<div class=\"toast\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\" style=\"pointer-events: auto;\"> \
  <div class=\"toast-header\"> \
    <strong class=\"mr-auto\"></strong> \
    <small class=\"text-muted\"></small> \
    <button type=\"button\" class=\"ml-2 mb-1 close\" data-dismiss=\"toast\" aria-label=\"Close\"> \
      <span aria-hidden=\"true\">&times;</span> \
    </button> \
  </div> \
  <div class=\"toast-body\"> \
  </div> \
</div>";
var _init_BAT_notifications = function _init_BAT_notifications() {
    if ($('#batToastsCntr').length === 0) {
        $("body").append(_htmlToastsContainer_BAT_notifications);
    }
};
var _showImp_BAT_notifications = function _showImp_BAT_notifications(headerHtml, headerText, headerSmall, body, autoClose, autoCloseMilliSeconds, cssClass) {
    _init_BAT_notifications();
    var newToast = $(_htmlToast_BAT_notifications);
    if (cssClass !== null && (typeof cssClass === "undefined" ? "undefined" : _typeof(cssClass)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        newToast.addClass(cssClass);
    }
    if (headerHtml !== null && (typeof headerHtml === "undefined" ? "undefined" : _typeof(headerHtml)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        newToast.find('.toast-header').eq(0).prepend(headerHtml).end();
    }
    if (headerText !== null && (typeof headerText === "undefined" ? "undefined" : _typeof(headerText)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        newToast.find('.toast-header strong').eq(0).text(headerText).end();
    }
    if (headerSmall !== null && (typeof headerSmall === "undefined" ? "undefined" : _typeof(headerSmall)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        newToast.find('.toast-header small').eq(0).text(headerSmall).end();
    }
    if (body !== null && (typeof body === "undefined" ? "undefined" : _typeof(body)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) {
        newToast.find('.toast-body').eq(0).text(body).end();
    } else {
        newToast.filter('.toast-body').eq(0).remove();
    }
    $('#batToastsCntr .batToastsCntrAbs').prepend(newToast);
    newToast.toast({
        delay: (typeof autoCloseMilliSeconds === "undefined" ? "undefined" : _typeof(autoCloseMilliSeconds)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) ? autoCloseMilliSeconds : 5000,
        autohide: (typeof autoClose === "undefined" ? "undefined" : _typeof(autoClose)) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) ? autoClose : true
    });
    $(newToast).on('hidden.bs.toast', function () {
        newToast.remove();
    });
    newToast.toast('show');
};

var _showInfo_BAT_notifications = function _showInfo_BAT_notifications(headerHtml, headerText, headerSmall, body, autoClose, autoCloseMilliSeconds, cssClass) {
    _init_BAT_notifications();
    _showImp_BAT_notifications(headerHtml, headerText, headerSmall, body, autoClose, autoCloseMilliSeconds, cssClass);
};

function showInfo(headerHtml, headerText, headerSmall, body, autoClose, autoCloseMilliSeconds, cssClass) {
    return _showInfo_BAT_notifications(headerHtml, headerText, headerSmall, body, autoClose, autoCloseMilliSeconds, cssClass);
};
},{"./BAT.localization.js":7}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showProcessing = showProcessing;
exports.showLoading = showLoading;
exports.showInitializing = showInitializing;
exports.showCustom = showCustom;
exports.hide = hide;
exports.setProgress = setProgress;

require('./BAT.localization.js');

require('./BAT.core.js');

var _changingState_BAT_progressDialog = null;
var _state_BAT_progressDialog = null;

var _htmlDiagContent_BAT_progressDialog = " <div class=\"modal fade\" id=\"progressModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"progressModalLabel\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\"> \
     <div class=\"modal-dialog\"> \
         <div class=\"modal-content\"> \
             <div class=\"modal-header\"> \
                 <h5 class=\"modal-title\" id=\"progressModalLabel\">Iniciar sesión</h5> \
             </div> \
             <div class=\"modal-body\"> \
                 <div class=\"progress\"> \
                     <div id=\"progressModalBar\" class=\"progress-bar progress-bar-success progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"> \
                         <span class=\"sr-only\">40% Complete (success)</span> \
                     </div> \
                 </div> \
             </div> \
         </div> \
     </div> \
 </div>";
var _resetState_BAT_progressDialog = function _resetState_BAT_progressDialog() {
    _changingState_BAT_progressDialog = false;
};
var _init_BAT_progressDialog = function _init_BAT_progressDialog() {
    if ($('#progressModal').length === 0) {
        var temp = {};
        $.extend(true, temp, BAT.lang.list, {
            "es-ES": {
                BAT: {
                    progressDialog: {
                        processing: 'Procesando...',
                        loading: 'Cargando...',
                        initializing: 'Inicializando'
                    }
                }
            },
            "en-GB": {
                BAT: {
                    progressDialog: {
                        processing: 'Processing...',
                        loading: 'Loading...',
                        initializing: 'Initializing'
                    }
                }
            },
            "de-DE": {
                BAT: {
                    progressDialog: {
                        processing: 'Processing...',
                        loading: 'Loading...',
                        initializing: 'Initializing'
                    }
                }
            }
        });
        BAT.lang.list = temp;
        $("body").append(_htmlDiagContent_BAT_progressDialog);

        $('#progressModal').on('shown.bs.modal', function (e) {
            _resetState_BAT_progressDialog();
            if (typeof _state_BAT_progressDialog !== 'undefined' && _state_BAT_progressDialog !== null) {
                _state_BAT_progressDialog.resolve();
            }
        });
        $('#progressModal').on('hidden.bs.modal', function (e) {
            _resetState_BAT_progressDialog();
            if (typeof _state_BAT_progressDialog !== 'undefined' && _state_BAT_progressDialog !== null) {
                _state_BAT_progressDialog.resolve();
            }
        });
    }
};
var _show_BAT_progressDialog = function _show_BAT_progressDialog(text, progress, animated) {
    _init_BAT_progressDialog();
    if (_changingState_BAT_progressDialog === null || _changingState_BAT_progressDialog === false) {
        _changingState_BAT_progressDialog = true;
        _state_BAT_progressDialog = $.Deferred(function (def) {
            $('#progressModalLabel').text(text);
            BAT.core.setProgress($('#progressModalBar'), progress);
            if (animated === true) {
                $('#progressModalBar').addClass('progress-bar-animated');
            } else {
                $('#progressModalBar').removeClass('progress-bar-animated');
            }
            $('#progressModal').modal('show');
        });
        return _state_BAT_progressDialog;
    } else {
        return $.Deferred(function (def) {
            def.reject('State Error. El diálogo ya se encuentra visible ');
        });
    }
};
var _hide_BAT_progressDialog = function _hide_BAT_progressDialog() {
    _init_BAT_progressDialog();
    if (_changingState_BAT_progressDialog === null || _changingState_BAT_progressDialog === false) {
        _changingState_BAT_progressDialog = true;
        _state_BAT_progressDialog = $.Deferred(function (def) {
            $('#progressModal').modal('hide');
        });
        return _state_BAT_progressDialog;
    } else {
        return $.Deferred(function (def) {
            def.reject('State Error. El diálogo ya se encuentra oculto ');
        });
    }
};
var _setProgress_BAT_progressDialog = function _setProgress_BAT_progressDialog(progress) {
    _init_BAT_progressDialog();
    BAT.core.setProgress($('#progressModalBar'), progress);
};
var _showProcessing_BAT_progressDialog = function _showProcessing_BAT_progressDialog(progreso) {
    _init_BAT_progressDialog();
    return _show_BAT_progressDialog(BAT.lang.list[BAT.lang.current].BAT.progressDialog.processing, progreso);
};
var _showLoading_BAT_progressDialog = function _showLoading_BAT_progressDialog(progreso) {
    _init_BAT_progressDialog();
    return _show_BAT_progressDialog(BAT.lang.list[BAT.lang.current].BAT.progressDialog.loading, progreso);
};

var _showInitializing_BAT_progressDialog = function _showInitializing_BAT_progressDialog(progreso) {
    _init_BAT_progressDialog();
    return _show_BAT_progressDialog(BAT.lang.list[BAT.lang.current].BAT.progressDialog.initializing, progreso);
};
var _showCustom_BAT_progressDialog = function _showCustom_BAT_progressDialog(mensaje, progreso, animada) {
    _init_BAT_progressDialog();
    return _show_BAT_progressDialog(mensaje, progreso, animada);
};
function showProcessing(progreso) {
    return _showProcessing_BAT_progressDialog(progreso);
};
function showLoading(progreso) {
    return _showLoading_BAT_progressDialog(progreso);
};
function showInitializing(progreso) {
    return _showInitializing_BAT_progressDialog(progreso);
};
function showCustom(mensaje, progreso, animada) {
    return _showCustom_BAT_progressDialog(mensaje, progreso, animada);
};
function hide() {
    return _hide_BAT_progressDialog();
};
function setProgress(progress) {
    return _setProgress_BAT_progressDialog(progress);
};
},{"./BAT.core.js":3,"./BAT.localization.js":7}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.execute = execute;
exports.executeCambiar = executeCambiar;
exports.executeReset = executeReset;
exports.executeCrear = executeCrear;

require('./BAT.localization.js');

var _state_BAT_restLoginDialog = null;
var _showingState_BAT_restLoginDialog = null;
var _resolveData_BAT_restLoginDialog = null;

var _htmlDiagContent_BAT_restLoginDialog = "<div class=\"modal fade\" id=\"passwordModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"passwordModalCaption\" aria-hidden=\"true\" data-backdrop=\"static\" data-keyboard=\"false\"> \
  <div class=\"modal-dialog\" > \
    <div class=\"modal-content\"> \
      <div class=\"modal-header\"> \
          <h3 id=\"passwordModalCaption\">Change Password <span class=\"extra-title muted\"></span></h3> \
      </div> \
      <div class=\"modal-body form-horizontal\"> \
          <div class=\"control-group\" id=\"current_password_cntr\"> \
              <label for=\"current_password\" class=\"control-label\">Current Password</label> \
              <div class=\"controls\"> \
                  <input type=\"password\" name=\"current_password\"> \
              </div> \
          </div> \
          <div class=\"control-group\"> \
              <label for=\"new_password\" class=\"control-label\">New Password</label> \
              <div class=\"controls\"> \
                  <input type=\"password\" name=\"new_password\"> \
              </div> \
          </div> \
          <div class=\"control-group\"> \
              <label for=\"confirm_password\" class=\"control-label\">Confirm Password</label> \
              <div class=\"controls\"> \
                  <input type=\"password\" name=\"confirm_password\"> \
              </div> \
          </div>       \
          <div class=\"alert alert-warning\" role=\"alert\"> \
            A simple warning alert—check it out! \
          </div> \
      </div> \
      <div class=\"modal-footer\"> \
          <button href=\"#\" class=\"btn\" data-dismiss=\"modal\" aria-hidden=\"true\" id=\"passwordModalClose\">Close</button> \
          <button href=\"#\" class=\"btn btn-primary\" id=\"passwordModalSave\">Save changes</button> \
      </div> \
     </div> \
  </div> \
</div>";
var _resetState_BAT_restLoginDialog = function _resetState_BAT_restLoginDialog() {
    _showingState_BAT_restLoginDialog = false;
    _resolveData_BAT_restLoginDialog = null;
    $('#passwordModal input[name="current_password"]').val('');
    $('#passwordModal input[name="new_password"]').val('');
    $('#passwordModal input[name="confirm_password"]').val('');
};
var _getUIData_BAT_restLoginDialog = function _getUIData_BAT_restLoginDialog() {
    return {
        currentPass: $('#passwordModal input[name="current_password"]').val(),
        newPass: $('#passwordModal input[name="new_password"]').val(),
        confirmPass: $('#passwordModal input[name="confirm_password"]').val()
    };
};
var _validateUIData_BAT_restLoginDialog = function _validateUIData_BAT_restLoginDialog(UIData) {
    return (!$('#passwordModal input[name="current_password"]').is(':visible') || !BAT.strings.stringIsNullOrEmpty(UIData.currentPass)) && !BAT.strings.stringIsNullOrEmpty(UIData.newPass) && !BAT.strings.stringIsNullOrEmpty(UIData.confirmPass) && UIData.newPass === UIData.confirmPass;
};
var _showCurrent_BAT_restLoginDialog = function _showCurrent_BAT_restLoginDialog() {
    $('#current_password_cntr').show();
};
var _hideCurrent_BAT_restLoginDialog = function _hideCurrent_BAT_restLoginDialog() {
    $('#current_password_cntr').hide();
};
var _showError_BAT_restLoginDialog = function _showError_BAT_restLoginDialog() {
    $('#passwordModal .alert').show();
};
var _hideError_BAT_restLoginDialog = function _hideError_BAT_restLoginDialog() {
    $('#passwordModal .alert').hide();
};
var _init_BAT_restLoginDialog = function _init_BAT_restLoginDialog() {
    if ($('#passwordModal').length === 0) {
        var temp = {};
        $.extend(true, temp, BAT.lang.list, {
            "es-ES": {
                BAT: {
                    passwordDialog: {
                        captionRenew: 'Restablecer contraseña',
                        captionChange: 'Cambiar contraseña',
                        captionNueva: 'Crear contraseña',
                        passwordCurrent: 'Contraseña actual',
                        passwordNew: 'Nueva contraseña',
                        passwordConfirm: 'Repetir nueva contraseña',
                        warning: 'Por favor, revise el formulario, las contraseñas no coinciden',
                        close: 'Cerrar'
                    }
                }
            },
            "en-GB": {
                BAT: {
                    passwordDialog: {
                        captionRenew: 'Reset password',
                        captionChange: 'Change password',
                        captionNueva: 'Create password',
                        passwordCurrent: 'Current password',
                        passwordNew: 'New password',
                        passwordConfirm: 'Repeat new password',
                        warning: 'Please check form, missing or incorrect values',
                        close: 'Close'
                    }
                }
            },
            "de-DE": {
                BAT: {
                    passwordDialog: {
                        captionRenew: 'Reset password',
                        captionChange: 'Change password',
                        captionNueva: 'Create password',
                        passwordCurrent: 'Current password',
                        passwordNew: 'New password',
                        passwordConfirm: 'Repeat new password',
                        warning: 'Please check form, missing or incorrect values',
                        close: 'Close'
                    }
                }
            }
        });
        BAT.lang.list = temp;
        $("body").append(_htmlDiagContent_BAT_restLoginDialog);


        $('#passwordModal button.btn-primary').on('click tap', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (_validateUIData_BAT_restLoginDialog(_getUIData_BAT_restLoginDialog())) {
                _resolveData_BAT_restLoginDialog = _getUIData_BAT_restLoginDialog();
                $('#passwordModal').modal('hide');
            } else {
                _showError_BAT_restLoginDialog();
            }
        });
        $('#passwordModal').on('hidden.bs.modal', function (e) {
            var resultado = JSON.parse(JSON.stringify(_resolveData_BAT_restLoginDialog));
            _resetState_BAT_restLoginDialog();
            if (typeof resultado !== 'undefined' && resultado !== null) {
                _state_BAT_restLoginDialog.resolve(resultado);
            } else {
                _state_BAT_restLoginDialog.reject();
            }
        });
        $('#passwordModal form').keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                event.stopPropagation();
                setTimeout(function () {
                    $('#passwordModal button.btn-primary').click();
                }, 0);
                return false;
            }
        });
    }
};
var _execute_BAT_restLoginDialog = function _execute_BAT_restLoginDialog(previousError, isChange, isNew) {
    _init_BAT_restLoginDialog();
    if (_showingState_BAT_restLoginDialog === null || _showingState_BAT_restLoginDialog === false) {
        _showingState_BAT_restLoginDialog = true;
        _state_BAT_restLoginDialog = $.Deferred(function (def) {
            if (isNew === true) {
                $('#passwordModalCaption').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.captionNueva);
                $('#passwordModalSave').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.captionNueva);
                $('#passwordModal label[for="current_password"]').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.passwordCurrent);
                _hideCurrent_BAT_restLoginDialog();
            } else if (isChange === true) {
                $('#passwordModalCaption').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.captionChange);
                $('#passwordModalSave').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.captionChange);
                $('#passwordModal label[for="current_password"]').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.passwordCurrent);
                _showCurrent_BAT_restLoginDialog();
            } else {
                $('#passwordModalCaption').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.captionRenew);
                $('#passwordModalSave').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.captionRenew);
                $('#passwordModal label[for="current_password"]').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.passwordCurrent);
                _hideCurrent_BAT_restLoginDialog();
            }
            $('#passwordModal label[for="current_password"]').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.passwordCurrent);
            $('#passwordModal label[for="new_password"]').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.passwordNew);
            $('#passwordModal label[for="confirm_password"]').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.passwordConfirm);
            $('#passwordModal .alert').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.warning);
            $('#passwordModalClose').text(BAT.lang.list[BAT.lang.current].BAT.passwordDialog.close);
            if (previousError === true) {
                _showError_BAT_restLoginDialog();
            } else {
                _hideError_BAT_restLoginDialog();
            }
            $('#passwordModal').modal('show');
        });
        return _state_BAT_restLoginDialog;
    } else {
        return $.Deferred(function (def) {
            def.reject('State Error. El diálogo ya se encuentra visible ');
        });
    }
};
function execute(previousError, isChange) {
    return _execute_BAT_restLoginDialog(previousError, isChange);
};
function executeCambiar(previousError) {
    return _execute_BAT_restLoginDialog(previousError, true, false);
};
function executeReset(previousError) {
    return _execute_BAT_restLoginDialog(previousError, false, false);
};
function executeCrear(previousError) {
    return _execute_BAT_restLoginDialog(previousError, false, true);
};
},{"./BAT.localization.js":7}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stringFormat = stringFormat;
exports.stringEndsWith = stringEndsWith;
exports.stringStartsWith = stringStartsWith;
exports.stringPadLeft = stringPadLeft;
exports.stringPadRight = stringPadRight;
exports.stringNormalize = stringNormalize;
exports.stringTrim = stringTrim;
exports.stringTrimLeft = stringTrimLeft;
exports.stringTrimStart = stringTrimStart;
exports.stringTrimRight = stringTrimRight;
exports.stringTrimEnd = stringTrimEnd;
exports.stringIsNullOrEmpty = stringIsNullOrEmpty;
exports.stringIsNullOrWhitespace = stringIsNullOrWhitespace;
var _from_BAT_stringsUtils = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
    _to_BAT_stringsUtils = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
    _mapping_BAT_stringsUtils = {};
function _initMapping_BAT_stringsUtils() {
    for (var i = 0, j = _from_BAT_stringsUtils.length; i < j; i++) {
        _mapping_BAT_stringsUtils[_from_BAT_stringsUtils.charAt(i)] = _to_BAT_stringsUtils.charAt(i);
    }
}
_initMapping_BAT_stringsUtils();
function _stringPad_BAT_stringsUtils(str, totalLength, padChar, left) {
    var pad = "";
    if (typeof padChar === 'undefined') {
        padChar = "0";
    }
    for (var i = 0; i < totalLength; i++) {
        pad += padChar;
    }
    if (left) {
        return pad.substring(0, pad.length - str.length) + str;
    } else {
        return str + pad.substring(0, pad.length - str.length);
    }
}
function _trim_BAT_stringsUtils(s, mask, left, right) {
    if (typeof mask !== 'undefined' && mask !== null) {
        if (left === true) {
            while (~mask.indexOf(s[0])) {
                s = s.slice(1);
            }
        }
        if (right === true) {
            while (~mask.indexOf(s[s.length - 1])) {
                s = s.slice(0, -1);
            }
        }
    }
    return s;
}
function stringFormat() {
    var s = arguments[0];
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        s = s.replace(reg, arguments[i + 1]);
    }
    return s;
}
function stringEndsWith(str, suffix) {
    return str.substr(str.length - suffix.length) === suffix;
}
function stringStartsWith(str, prefix) {
    return str.substr(0, prefix.length) === prefix;
}
function stringPadLeft(str, totalLength, padChar) {
    return _stringPad_BAT_stringsUtils(str, totalLength, padChar, true);
}
function stringPadRight(str, totalLength, padChar) {
    return _stringPad_BAT_stringsUtils(str, totalLength, padChar, false);
}
function stringNormalize(str) {
    var ret = [];
    for (var i = 0, j = str.length; i < j; i++) {
        var c = str.charAt(i);
        if (_mapping_BAT_stringsUtils.hasOwnProperty(str.charAt(i))) ret.push(_mapping_BAT_stringsUtils[c]);else ret.push(c);
    }
    return ret.join('');
}
function stringTrim(str, mask) {
    return _trim_BAT_stringsUtils(str, mask, true, true);
}
function stringTrimLeft(str, mask) {
    return _trim_BAT_stringsUtils(str, mask, true, false);
}
function stringTrimStart(str, mask) {
    return _trim_BAT_stringsUtils(str, mask, true, false);
}
function stringTrimRight(str, mask) {
    return _trim_BAT_stringsUtils(str, mask, false, true);
}
function stringTrimEnd(str, mask) {
    return _trim_BAT_stringsUtils(str, mask, false, true);
}
function stringIsNullOrEmpty(str) {
    return str === null || typeof str === 'undefined' || str === '';
}
function stringIsNullOrWhitespace(str) {
    return stringIsNullOrEmpty(str) || _trim_BAT_stringsUtils(str, " ", true, true) === '';
}
String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};
String.prototype.format = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringFormat.apply(target, args);
};
String.prototype.endsWith = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringEndsWith.apply(target, args);
};
String.prototype.startsWith = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringStartsWith.apply(target, args);
};
String.prototype.padLeft = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringPadLeft.apply(target, args);
};
String.prototype.padRight = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringPadRight.apply(target, args);
};
String.prototype.normalize = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringNormalize.apply(target, args);
};
String.prototype.trim = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringTrim.apply(target, args);
};
String.prototype.trimLeft = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringTrimLeft.apply(target, args);
};
String.prototype.trimStart = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringTrimLeft.apply(target, args);
};
String.prototype.trimRight = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringTrimRight.apply(target, args);
};
String.prototype.trimEnd = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringTrimRight.apply(target, args);
};
String.prototype.isNullOrEmpty = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringIsNullOrEmpty.apply(target, args);
};
String.prototype.isNullOrWhitespace = function () {
    var target = this;
    var args = [this].concat(Array.prototype.slice.call(arguments));
    return stringIsNullOrWhitespace.apply(target, args);
};
String.prototype.pluralES = function () {
    var target = this;

    function esGrupoA() {
        return this.length > 0 && this[this.length - 1] in ['a', 'e', 'i', 'o', 'u', 'é'];
    }
    function esGrupoB() {
        return this.length > 0 && this[this.length - 1] in ['á', 'ó'];
    }
    function esGrupoC() {
        return this.length > 0 && this[this.length - 1] in ['í', 'ú'];
    }
    function esGrupoD() {
        return this.length > 1 && ['ay', 'ey', 'iy', 'oy', 'uy'].indexOf(this.substring(this.length - 2)) > -1;
    }

    function esGrupoE() {}
    function esGrupoF() {}
    function esGrupoG() {}
    function esGrupoH() {}
    function esGrupoI() {}
    if (esGrupoA.apply(target)) {
        return this + 's';
    } else if (esGrupoB.apply(target)) {
        return this + 's';
    } else if (esGrupoC.apply(target)) {
        return this + 'es';
    } else if (esGrupoD.apply(target)) {
        return this + 'es';
    } else {
        return this;
    }
};
String.prototype.singularES = function () {
    if (this.length > 1 && this.substring(this.length - 2).toLowerCase() === 'es') {
        return this.substring(0, this.length - 2);
    } else if (this.length > 0 && this[this.length - 1].toLowerCase() === 's') {
        return this.substring(0, this.length - 1);
    } else {
        return this;
    }
};
String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
},{}]},{},[6]);
